var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<nav><ul class=\"pager\"><li ng-show=\"paginator.mode === &quot;replace&quot;\" ng-class=\"{disabled: (!paginator.$prev || paginator.reqInProgress)}\"><a href=\"#\" ng-click=\"changePage(&quot;prev&quot;)\" class=\"button\">Previous </a></li><li ng-show=\"paginator.mode === &quot;replace&quot;\" ng-class=\"{disabled: (!paginator.$next || paginator.reqInProgress)}\"><a href=\"#\" ng-click=\"changePage(&quot;next&quot;)\" class=\"button\">Next </a></li><li ng-show=\"paginator.mode === &quot;append&quot;\" ng-class=\"{disabled: (!paginator.$next || paginator.reqInProgress)}\"><a href=\"#\" ng-click=\"changePage(&quot;next&quot;)\" class=\"button\">More </a></li></ul></nav>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/common/directives/pager.jade
 ** module id = 814
 ** module chunks = 0 1 3 4 5 6
 **/